export default class ConnectionList {
  #connections = [];
  #preventDuplicates = false;
  #doAdd = (connection) => {
    if (this.#preventDuplicates && this.has(connection)) {
      connection.close();
      return;
    }

    this.#connections.push(connection);
  };

  constructor(preventDuplicates = false) {
    this.#preventDuplicates = preventDuplicates;
  }

  get preventDuplicates() {
    return this.#preventDuplicates;
  }

  set preventDuplicates(value) {
    this.#preventDuplicates = value;
  }

  get connections() {
    return this.#connections;
  }

  add(connection) {
    if (connection.open) {
      this.#doAdd(connection);
    }

    connection.on('open', () => {
      this.#doAdd(connection);
    });

    connection.on('close', () => {
      console.log('Connection closed', connection.peer);
      this.remove(connection);
    });
    connection.on('error', () => {
      if (!connection.open) {
        this.remove(connection);
      }
    });
  }

  has(connection) {
    return (
      this.#connections.filter((c) => c.peer === connection.peer).length > 0
    );
  }

  remove(connection) {
    const index = this.#connections.findIndex(
      (c) => c.peer === connection.peer
    );

    if (index !== -1) {
      this.#connections.splice(index, 1);
    }
  }

  empty() {
    this.#connections = [];
  }
}
